import * as React from 'react'
import { cn } from '@/lib/utils'

export interface BaseFileUploadProps {
  accept?: string
  multiple?: boolean
  onFiles: (files: File[]) => void
  label?: React.ReactNode
  className?: string
  disabled?: boolean
}

export function BaseFileUpload({ accept, multiple, onFiles, label, className, disabled }: BaseFileUploadProps) {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = Array.from(e.target.files ?? [])
    onFiles(f)
    e.target.value = ''
  }
  return (
    <label
      className={cn(
        'flex cursor-pointer items-center justify-center rounded-md border border-dashed border-border p-6 text-sm text-foreground/70 hover:bg-muted',
        disabled && 'pointer-events-none opacity-60',
        className,
      )}
    >
      <input className="hidden" type="file" accept={accept} multiple={multiple} onChange={onChange} disabled={disabled} />
      {label || 'Clique para selecionar arquivos'}
    </label>
  )
}
